import {
  Grid,
  Typography,
  Card,
  CardContent,
  CardMedia,
  Box,
  Button,
  CardActions,
  Breadcrumbs,
  Link as MuiLink,
  Skeleton,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import { Link, useNavigate } from "react-router-dom";
import React, { useContext, useState } from "react";
import { CountryContext } from "../MainComponent";
import { useQuery } from "@apollo/client";
import * as queries from "../../../operations/queries";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { useTranslation } from "react-i18next";

const Blog = () => {
  const { store } = useContext(CountryContext);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const navigate = useNavigate()
  const {t} = useTranslation()
  const [visibleCount, setVisibleCount] = useState(isMobile ? 10 : 15);

  const { data: filterDataRes, loading } = useQuery(
    queries.productQueries.BLOG_LIST,
    {
      context: {
        headers: {
          Connection: "keep-alive",
          // store: store,
        },
      },
    }
  );

  const blogData = filterDataRes?.getAllPosts;
  const blogItems = blogData?.items; const totalItems = blogItems?.length || 0;

  const handleLoadMore = () => {
    const increment = isMobile ? 5 : 10;
    setVisibleCount((prev : number) => Math.min(prev + increment, totalItems));
  };

  const handleLoadLess = () => {
    const defaultCount = isMobile ? 10 : 15;
    setVisibleCount(defaultCount);
  };

  if (loading) {
    return (
      <Box sx={{ py: 4, px: 4 }} className="directionrtl">
        <Skeleton
          variant="rectangular"
          width="100%"
          height={300}
          sx={{ mb: 4 }}
        />
        <Grid container spacing={3}>
          {[...Array(8)].map((_, index) => (
            <Grid item xs={12} sm={6} md={3} key={index}>
              <Card>
                <Skeleton variant="rectangular" height={140} />
                <CardContent>
                  <Skeleton variant="text" width="80%" />
                  <Skeleton variant="text" width="60%" />
                  <Skeleton variant="text" width="40%" />
                </CardContent>
                <CardActions>
                  <Skeleton variant="rectangular" width={100} height={36} />
                </CardActions>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Box>
    );
  }

  return (
    <Box sx={{ py: 4, px: 4 }} className="directionrtl">
      <Breadcrumbs
        separator={<ArrowForwardIosIcon fontSize="small" />}
        aria-label="breadcrumb"
        sx={{ mb: 3 }}
      >
        <MuiLink
          component={Link}
          to={`/${store}`}
          color="inherit"
          sx={{ display: "flex", alignItems: "center" }}
        >
        {t("blog.home")}
        </MuiLink>
        <MuiLink
          component={Link}
          to={`/${store}/blog`}
          color="text.primary"
          sx={{ display: "flex", alignItems: "center" }}
        >
         {t("blog.blogTitle")}
        </MuiLink>
      </Breadcrumbs>

      {blogData?.banner && (
        <Box
          sx={{
            mb: 4,
            borderRadius: 1,
            overflow: "hidden",
            boxShadow: 3,
            position: "relative",
            height: isMobile ? 300 : 400,
            "&:hover img": {
              transform: "scale(1.03)",
            },
          }}
        >
          <CardMedia
            component="img"
            image={blogData.banner}
            alt="Blog Banner"
            sx={{
              height: "100%",
              width: "100%",
              objectFit: "cover",
              transition: "transform 0.5s ease",
            }}
          />
          <Box
            sx={{
              position: "absolute",
              bottom: 0,
              left: 0,
              right: 0,
              p: 3,
              background:
                "linear-gradient(to top, rgba(0,0,0,0.7) 0%, rgba(0,0,0,0.3) 70%, transparent 100%)",
            }}
          >
            <Typography
              variant="h4"
              component="h1"
              color="white"
              fontWeight="bold"
            >
              {t("blog.our_blog")}
            </Typography>
            <Typography variant="subtitle1" color="rgba(255,255,255,0.8)">
            {t("blog.small_desc")}
            </Typography>
          </Box>
        </Box>
      )}

      <Grid container spacing={2}>
        {blogItems?.slice(0, visibleCount)?.map((article: any, index: any) => (
          <Grid item xs={12} sm={12} md={6} lg={4} key={index}>
            <Card
              sx={{
                height: "100%",
                display: "flex",
                flexDirection: "column",
              }}
            >
              <Box
                sx={{ position: "relative", overflow: "hidden", height: 200 }}
              >
                <CardMedia
                  component="img"
                  image={article.thumbnail}
                  alt={article.title}
                  sx={{
                    height: "100%",
                    width: "100%",
                    objectFit: "cover",
                    transition: "transform 0.5s ease",
                    "&:hover": {
                      transform: "scale(1.1)",
                    },
                  }}
                />
                {article.created_at && (
                  <Box
                    sx={{
                      position: "absolute",
                      top: 10,
                      right: 10,
                      backgroundColor: "primary.main",
                      color: "white",
                      px: 1.5,
                      py: 0.5,
                      borderRadius: 1,
                      fontSize: 12,
                      fontWeight: "bold",
                    }}
                  >
                    {article?.created_at}
                  </Box>
                )}
              </Box>
              <CardContent sx={{ flexGrow: 1 }}>
                <Typography
                  gutterBottom
                  variant="h6"
                  component="div"
                  sx={{ fontWeight: 600 }}
                >
                  {article.title}
                </Typography>
                <Typography
                  variant="body2"
                  color="text.secondary"
                  sx={{ mb: 2 }}
                >
                  {article.short_description}
                </Typography>
              </CardContent>
              <CardActions sx={{ justifyContent: "flex-end" }}>
                <Button
                  component={Link}
                  to={`/${store}/blog/${article.link}`}
                  size="small"
                  endIcon={<ArrowForwardIcon />}
                  sx={{
                    fontWeight: 600,
                    textTransform:"none"
                    // "&:hover": {
                    //   backgroundColor: "primary.light",
                    //   color: "primary.contrastText",
                    // },
                  }}
                >
                  {t("blog.read_more")}
                </Button>
              </CardActions>
            </Card>
          </Grid>
        ))}
      </Grid>

      {totalItems > (isMobile ? 10 : 15) && (
        <Box sx={{ display: "flex",  mt: 4, gap: 2 }}>
          {visibleCount < totalItems && (
            <Button
              variant="outlined"
              onClick={handleLoadMore}
              sx={{ px: 3, py: 1 ,textTransform:"none"}}
            >
              {t("blog.load_more")}
            </Button>
          )}
          {visibleCount > (isMobile ? 10 : 15) && (
            <Button
              variant="outlined"
              onClick={handleLoadLess}
              sx={{ px: 3, py: 1 ,textTransform:"none"}}
            >
             {t("blog.show_less")}
            </Button>
          )}
        </Box>
      )}

      {!loading && (!blogItems || blogItems.length === 0) && (
        <Box
          sx={{
            textAlign: "center",
            py: 10,
            border: "1px dashed",
            borderColor: "divider",
            borderRadius: 2,
            mt:2
          }}
        >
          <Typography variant="h6" color="text.secondary">
          {t("blog.no_blog")}
          </Typography>
          <Button
            variant="outlined"
            sx={{ mt: 2 }}
            onClick={() => navigate(`/${store}`)}
          >
            {t("blog.go_to_home_page")}
          </Button>
        </Box>
      )}
    </Box>
  );
};

export default Blog;
